var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{},[_vm._m(0),_c('VodLibrary',{attrs:{"data":_vm.trainerSessionListData}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shadow p-3 rounded-lg bg-white mb-4"},[_c('h3',{staticClass:"mb-2 font-semibold md:text-2xl text-lg"},[_vm._v("On Demand Classes")])])
}]

export { render, staticRenderFns }